import React, {useState} from 'react';

export interface ExpandableTextProps {
  children: string;
  maxLength?: number;
  className?: string;
  buttonClassName?: string;
  seeMoreText?: string;
  seeLessText?: string;
  preserveWhitespace?: boolean;
  disabled?: boolean;
}

export const ExpandableText: React.FC<ExpandableTextProps> = ({
  children,
  maxLength = 300,
  className = '',
  buttonClassName = '',
  seeMoreText = 'See more',
  seeLessText = 'See less',
  preserveWhitespace = true,
  disabled = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!children) return null;

  const shouldTruncate = children.length > maxLength && !disabled;

  const displayText = shouldTruncate && !isExpanded ? children.substring(0, maxLength).trim() + '...' : children;

  const defaultButtonClasses = 'mt-2 text-blue-600 hover:text-blue-800 font-medium text-sm transition-colors cursor-pointer';
  const finalButtonClasses = buttonClassName ? `${defaultButtonClasses} ${buttonClassName}`.trim() : defaultButtonClasses;

  const textClasses = preserveWhitespace ? `${className} whitespace-pre-wrap`.trim() : className;

  return (
    <div>
      <div className={textClasses}>{displayText}</div>

      {shouldTruncate && (
        <button onClick={() => setIsExpanded(!isExpanded)} className={finalButtonClasses} type="button">
          {isExpanded ? seeLessText : seeMoreText}
        </button>
      )}
    </div>
  );
};
